import { useState, useEffect } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Header from '../header/Header';
import Sidebar from '../sidebar/Sidebar';
import methods from '../../services/utility';
import StepProgress from '../../views/public/stepProgress/StepProgress';

const Layout = ({ component: Component, ...rest }) => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);

  const isUserLogedin = methods.checkUserLogin();

  const checkUserInAccessList = () => {
    var roles = methods.getUserRoles();
    if (!methods.checkSalesUserRoles(roles))
      navigate("/login");
    console.log("cheched user access");
  }

  useEffect(() => {
    const fetchData = async () => {
      checkUserInAccessList();
    }
    fetchData();
  }, []);



  return (
    <div className='container-fluid'>
      {isUserLogedin ?
        <>
          <Header setCollapsed={setCollapsed} />
          <div className='row bg-light layout'>
            <div className={`col-lg-${collapsed ? 1 : 2} border-end border-secondary-subtle p-0`}>
              <Sidebar setCollapsed={setCollapsed} collapsed={collapsed} />
            </div>
            <div className="col-lg-10 p-4 mx-auto">
              <StepProgress />
              <Component {...rest} />
            </div>
          </div>
        </>
        :
        <Navigate to="/login" />
      }
    </div>
  )
};

export default Layout;